import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'

import { modelNames } from '@/data/models/types'
import { ExternalIntegration, ExternalIntegrationProvider } from '@/data/models/domain/externalIntegrations'
import type { HubspotExternalIntegrationSettings } from '@/services/domain/externalIntegrations/types'

@OrmModel(modelNames.HUBSPOT_EXTERNAL_INTEGRATION, modelNames.EXTERNAL_INTEGRATION)
export class HubspotExternalIntegration extends ExternalIntegration {
  @StringField(ExternalIntegrationProvider.HUBSPOT)
  public provider: ExternalIntegrationProvider.HUBSPOT

  @AttrField(null)
  public settings: HubspotExternalIntegrationSettings | null
}

export default HubspotExternalIntegration
